const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export class DateValidator {
  errors = [];
  static isValidDateFormat(str) {
    if (typeof str !== "string" || !DATE_REGEX.test(str)) return false;
    const [y, m, d] = str.split("-").map(Number);
    const date = new Date(y, m - 1, d);
    return (
      date.getFullYear() === y &&
      date.getMonth() === m - 1 &&
      date.getDate() === d
    );
  }

  static isNotMalicious(str) {
    if (typeof str !== "string") return false;
    const dangerous = /[<>"'&]|script|onerror|onload|javascript:/i;
    return !dangerous.test(str);
  }

  static isDateRangeValid(f1, f2) {
    if (!this.isValidDateFormat(f1) || !this.isValidDateFormat(f2)) {
      return false;
    }
    return new Date(f1) <= new Date(f2);
  }

  static validate(f1, f2) {
    this.errors = [];

    if (!this.isValidDateFormat(f1)) {
      this.errors.push("La fecha 1 no tiene un formato de fecha válido (YYYY-MM-DD)");
    }
    if (!this.isNotMalicious(f1)) {
      this.errors.push("La fecha 1 contiene caracteres o palabras peligrosas");
    }
    if (!this.isValidDateFormat(f2)) {
      this.errors.push("La fecha 2 no tiene un formato de fecha válido (YYYY-MM-DD)");
    }
    if (!this.isNotMalicious(f1)) {
      this.errors.push("La fecha 2 contiene caracteres o palabras peligrosas");
    }
    if (this.errors.length === 0 && !this.isDateRangeValid(f1, f2)) {
      this.errors.push("La fecha 1 no puede ser mayor que fecha 2");
    }
    return { valid: this.errors.length === 0, errors: this.errors };
  }
}
